import React from "react";
import classes from "./styles.module.scss";
import classNames from "classnames";
import WarningIcon from "assets/images/icons/warning.svg";

const typeClasses = (type) =>
    ({
        info: classes.info,
        warning: classes.warning,
        error: classes.error,
        default: "",
    })[type || "default"];

const typeIcons = (type) =>
    ({
        warning: WarningIcon,
        default: "",
    })[type || "default"];

const FixedBanner = ({ className, type, children }) => {
    const Icon = typeIcons(type);

    return (
        <div className={classNames(classes.fixedBanner, {
            [typeClasses(type)]: type,
            [className]: className,
        })}>
            {Icon && (<img src={Icon} alt={`${type}_icon`} />)}
            {children}
        </div>
    )
};

export default FixedBanner;